module.exports = __webpack_public_path__ + "c.no1.f12fbb9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/c.no1.jpg
// module id = TF/A
// module chunks = 0